import { Flex, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
import TableViewButton from '@components/button/TableViewButton.'
import TableEditButton from '@components/button/TableEditButton'
import TableDeleteButton from '@components/button/TableDeleteButton'

import { ITHeadMap } from '@interfaces/ITable'
import { Link } from 'react-router-dom'
import TableAddNewButton from '@components/button/TableAddNewButton'
import { modals } from '@mantine/modals'
import { QueryObserverResult } from 'react-query'
import {
    IResponseGetAllBudgetYears,
    IResponseGetAllBudgetYearsRowData,
} from '@interfaces/api/IBudgetYear'
import BudgetYear from '@api/BudgetYear'
import TableSearchFilter from '@components/table/filter/TableSearchFilter'
import TablePagination from '@components/table/template/TablePagination'
import TableTemplate from '@components/table/template/TableTemplate'
const TableAllBudgetYear = () => {
    const [limit, setlimit] = useState(10)
    const [orderby, setorderby] =
        useState<keyof IResponseGetAllBudgetYearsRowData>('budget_year')
    const [order, setorder] = useState('desc')
    const [page, setpage] = useState(1)
    const [search, setsearch] = useState('')
    const lists = BudgetYear.useGetAllBudgetYears({
        limit,
        orderby,
        order,
        page,
        search,
    })

    useEffect(() => {
        lists.refetch()
        // eslint-disable-next-line
    }, [page, limit, order, orderby])

    const thead: ITHeadMap<IResponseGetAllBudgetYearsRowData>[] = [
        {
            sortkey: 'budget_year',
            label: 'รหัสปี',
            width: '8%',
        },
        {
            sortkey: 'budget_year_name',
            label: 'ชื่อปีงบประมาณ',
            width: '30%',
        },
        {
            label: 'Action',
            width: '10%',
        },
    ]

    return (
        <>
            <Flex gap='md' direction={{ xs: 'column', lg: 'row' }}>
                <TableSearchFilter
                    page={page}
                    setpage={setpage}
                    setsearch={setsearch}
                    search={search}
                    refresh={lists.refetch}
                />
                <TableAddNewButton
                    component={Link}
                    to='/budgetyears/create'
                    label='เพิ่มปีงบประมาณ'
                />
            </Flex>

            <TableTemplate<IResponseGetAllBudgetYearsRowData>
                thead={thead}
                orderby={orderby}
                order={order}
                setorder={setorder}
                setorderby={setorderby}
                lists={lists?.data?.lists}
            >
                {lists?.data?.lists.map((value) => (
                    <AllBudgetYearTableRow
                        key={value.budget_year}
                        data={value}
                        refreshTable={lists.refetch}
                    />
                ))}
            </TableTemplate>
            {lists.data?.lists.length ? (
                <TablePagination
                    limit={lists.data?.lists.length}
                    setlimit={setlimit}
                    setpage={setpage}
                    page={page}
                    totalPages={lists.data.totalPages}
                    totalRows={lists.data.totalRows}
                />
            ) : (
                <></>
            )}
        </>
    )
}

export default TableAllBudgetYear

const AllBudgetYearTableRow = ({
    data,
    refreshTable,
}: {
    data: IResponseGetAllBudgetYearsRowData
    refreshTable: () => Promise<
        QueryObserverResult<IResponseGetAllBudgetYears, unknown>
    >
}) => {
    const Delete = BudgetYear.useDeleteBudgetYear({
        budget_year: data.budget_year,
        aftersuccess: refreshTable,
    })

    const openDeleteConfirmModal = () =>
        modals.openConfirmModal({
            title: 'กรุณายืนยันการลบ',
            children: (
                <Text>
                    ลบปีงบประมาณ <br />
                    {data.budget_year_name}
                </Text>
            ),
            labels: { confirm: 'ยืนยัน', cancel: 'ยกเลิก' },
            onConfirm: Delete.onSubmit,
        })

    return (
        <tr key={data.budget_year}>
            <td>{data.budget_year}</td>
            <td>{data.budget_year_name}</td>
            {/* <DateAndFullNameColumn
                day={data.created_at}
                fullname={data.created_by_user_fullname}
                user_id={data.created_by_user_id}
            />
            <DateAndFullNameColumn
                day={data.updated_at}
                fullname={data.updated_by_user_fullname}
                user_id={data.updated_by_user_id}
            /> */}
            <td>
                <Flex gap='xs' pos='relative'>
                    <TableViewButton
                        component={Link}
                        to={`/budgetyears/${data.budget_year}/view`}
                    />
                    <TableEditButton
                        component={Link}
                        to={`/budgetyears/${data.budget_year}/edit`}
                    />
                    <TableDeleteButton onClick={openDeleteConfirmModal} />
                </Flex>
            </td>
        </tr>
    )
}
